module.exports = __webpack_public_path__ + "img/second-0-opened.b91cb773.webp";